import React, { createContext, useEffect, useState } from 'react'
import { useCookies } from 'react-cookie';

export const Settings = createContext();

function SettingsProvider({ children }) {
    const [openMenu, setOpenMenu] = useState(false);
    const [screenWidth, setScreenWidth] = useState(window.innerWidth);
    const [overlay, setOverlay] = useState(false);
    const [openSearch, setOpenSearch] = useState(false);
    const [openSwitcher, setOpenSwitcher] = useState(false);
    const [profileSetting, setProfileSetting] = useState(false);
    const [openNotification, setOpenNotification] = useState(false);
    const [openProfile, setOpenProfile] = useState(false);
    const [cookies, setCookie, removeCookie] = useCookies(['settings']);
    const [mode, setMode] = useState(cookies.settings?.mode || 'light');

    const clickMode = () => {
        const newMode = mode === 'light' ? 'dark' : 'light';
        setMode(newMode);
    };

    // Yeni `settings`-ə uyğun olaraq kukini yeniləmək
    useEffect(() => {
        setCookie('settings', { mode: mode }, {
            path: '/',
            expires: new Date(Date.now() + 3600 * 24 * 1000) // 1 gün sonra
        });
        document.documentElement.setAttribute('data-theme-mode', mode);
        document.documentElement.setAttribute('data-header-styles', mode);
        document.documentElement.setAttribute('data-menu-styles', mode);
    }, [mode, setCookie]);

    useEffect(() => {
        const handleResize = () => {
            setScreenWidth(window.innerWidth);
        };

        window.addEventListener("resize", handleResize);

        return () => {
            window.removeEventListener("resize", handleResize);
        };
    }, []);
    useEffect(() => {
        console.log(screenWidth)
        if (screenWidth < 992) {
            document.documentElement.setAttribute("data-toggled", "close");
        } else {
            document.documentElement.setAttribute("data-toggled", "menu-click-closed");
            setOpenMenu(false);
            setOverlay(false);
        }
    }, [screenWidth]);

    // settings*********
    const clickMenu = (e) => {
        e.preventDefault();
        setOpenMenu(!openMenu);
        if (openMenu) {
            document.documentElement.setAttribute("data-toggled", screenWidth > 992 ? "menu-click-closed" : "close");
        } else {
            if (screenWidth > 992) {
                document.documentElement.removeAttribute("data-toggled");
            } else {
                document.documentElement.setAttribute("data-toggled", "open");
                setOverlay(true);
            }
        }
    }

    const clickAvatar = (e) => {
        e.preventDefault();
        setProfileSetting(!profileSetting);
    }

    const clickOverlay = () => {
        if (screenWidth < 992 && document.documentElement.getAttribute("data-toggled") === "open") {
            document.documentElement.setAttribute("data-toggled", "close");
            setOverlay(false);
            setOpenMenu(false);
        }
    }

    const clickDropMenu = (e) => {
        e.preventDefault();
        const target = e.currentTarget;
        const allSubMenus = document.querySelectorAll('.has-sub');

        allSubMenus.forEach((item) => {
            if (item !== target) {
                item.classList.remove("open");
                const submenu = item.querySelector("ul");
                if (submenu) {
                    submenu.style.display = "none";
                }
            }
        });

        const submenu = target.querySelector("ul");
        if (submenu) {
            target.classList.toggle("open");

            if (target.classList.contains("open")) {
                submenu.style.display = "block";
            } else {
                submenu.style.display = "none"; 
            }
        }
    }

    const clickSearch = (e) => {
        e.preventDefault();
        setOpenSearch(!openSearch);
    }

    const clickSwitcher = (e) => {
        e.preventDefault();
        setOpenSwitcher(!openSwitcher);
    }
    return (
        <Settings.Provider value={{ mode, clickMode, screenWidth, clickAvatar, profileSetting, openMenu, clickMenu, clickOverlay, overlay, clickDropMenu, clickSearch, openSearch, openSwitcher, clickSwitcher }}>
            {children}
        </Settings.Provider>
    )
}

export default SettingsProvider